if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.productInformation = this.closest('.product__info-container');
        this.productcontent = document.querySelector('.itg-product');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.spantext = this.querySelector('.variant-price');
        printMessage();
        // this.popupProductBtn = document.querySelector('.mobile-add-to-cart__button');
        // if(this.popupProductBtn){
        //    this.popupBtnLoader = this.popupProductBtn.querySelector('.loading__spinner');
        // }
        
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        if(this.productInformation){
          this.sizeChart();
        }
        
      }

      
        //Size chart js for page
      //   sizeChart(){
      //     if(this.productcontent){
      //     let sizeChart = this.productInformation.querySelector('.chart_size');
      //     if(sizeChart && sizeChart.href){
      //       sizeChart.href = sizeChart.href.replace('/products/',"/");
      //       console.log(sizeChart);
      //     }
      //   }
      // }

      sizeChart() {
        let sizeChart = this.productInformation.querySelector('.chart_size');
        let pageContentPopup = document.querySelector('.page_contents');
        let canclePopupsize = document.querySelector('.cancle-size');
        let modalPopupOverlay = document.querySelector('.modal-popup__overlay');
        let bodyOverall = document.body;
        if (sizeChart) {
          sizeChart.addEventListener('click', function(event){
            event.stopPropagation();
          pageContentPopup.classList.add('active');
          bodyOverall.classList.add('overflow-hidden');
          });
        }
        if (canclePopupsize) {
          canclePopupsize.addEventListener('click', function(event){
            event.stopPropagation();
          pageContentPopup.classList.remove('active');
          bodyOverall.classList.remove('overflow-hidden');
          });
        }
        if (pageContentPopup) {
          pageContentPopup.addEventListener('click', function(event){
            event.stopPropagation();
          });
        }
        window.addEventListener('click', function(){
          if(pageContentPopup){
            pageContentPopup.classList.remove('active');
            bodyOverall.classList.remove('overflow-hidden');
          }
        });
      }
      

      //New function
      updateMiniFooterCart() {
        fetch(window.location.pathname + '?section_id=footer-mini-cart')
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newMiniCart = doc.querySelector('#footer-mini-cart');
            const currentMiniCart = document.querySelector('#footer-mini-cart');

            if (newMiniCart && currentMiniCart) {
              currentMiniCart.innerHTML = newMiniCart.innerHTML;
              // console.log('Mini footer cart updated!');
            } else {
              console.error('Mini cart elements not found during update.');
            }
          })
          .catch(error => {
            console.error('Error updating mini footer cart:', error);
          });
         
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
       
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if(this.productcontent){
          //this.popupProductBtn.classList.add('loading');
          if(this.popupBtnLoader){
            this.popupBtnLoader.classList.remove('hidden');
          }
        }
       
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const addedItem = response.items?.[response.items.length - 1];
            if (addedItem) {
              console.log('Added Product JSON:', {
                image: addedItem.image,
                quantity: addedItem.quantity
              });
              
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
           const quickAddModal = this.closest('quick-add-modal');
            const addMoreSaveMoreSection = document.querySelector('.add-more-save-more');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  //New function
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    initEncapsulatedToggle();  
                    bindRemoveCartItemEvents();  
                    this.updateMiniFooterCart(); 
                  }, 200);
                },
                { once: true }
              );
              if (!addMoreSaveMoreSection) {
                quickAddModal.hide(true);
              }
            } else {
              this.cart.renderContents(response);
              setTimeout(() => {
                initEncapsulatedToggle();
                bindRemoveCartItemEvents();
                this.updateMiniFooterCart();
              }, 200);
            }
            setTimeout(() => {
              this.updateMiniFooterCart();
            }, 300);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if(this.productcontent){
               //this.popupProductBtn.classList.remove('loading');
            }
           
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if(this.popupBtnLoader){
              this.popupBtnLoader.classList.add('hidden');
            }
          });

          setTimeout(() => {
            printMessage();
          }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

//New function
async function bindRemoveCartItemEvents() {
  const forms = document.querySelectorAll('.remove-cart-item-form');

  forms.forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      try {
       
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

       
        const response = await fetch(window.location.pathname + '?section_id=footer-mini-cart');
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        
        const newCart = html.querySelector('#footer-mini-cart');
        const oldCart = document.querySelector('#footer-mini-cart');
        if (newCart && oldCart) {
          oldCart.innerHTML = newCart.innerHTML;
        }

        // Re-bind events
        bindRemoveCartItemEvents();
        // filterMicroCartItems();

      } catch (error) {
        console.error('Cart update error:', error);
      }
    });
  });
}

 document.addEventListener('DOMContentLoaded', bindRemoveCartItemEvents);


 
